import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Box,
  Divider
} from "@mui/material";
import {
  ExpandLess,
  ExpandMore,
  Home
} from "@mui/icons-material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/logostx.jpg";
import { setActiveTabByPath } from "../tabs/tabsSlice";
import { useDispatch } from "react-redux";

const MobileDrawer = ({ pages, handleNavigate, drawerOpen, setDrawerOpen }) => {
  const [expanded, setExpanded] = useState(null);
  const navigate = useNavigate();
    const dispatch = useDispatch();

  const handleExpand = (index) => {
    setExpanded(expanded === index ? null : index);
  };

  const handleHome = () => {
    navigate("/home");
    dispatch(setActiveTabByPath(null));
    setDrawerOpen(false);
  };
  const handleNavigateAndClose = (linkOrText) => {
    handleNavigate(linkOrText);
    setDrawerOpen(false);
  };

  return (
    <Drawer
      anchor="left"
      open={drawerOpen}
      onClose={() => setDrawerOpen(false)}
      sx={{ "& .MuiDrawer-paper": { width: 280, background: "#6F130F", color: "white", display: 'flex', flexDirection: 'column', height: '100%' } }}
    >
      <Box sx={{ width: 280, height: "100%", display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
        {/* Logo con estilo personalizado */}
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", pt: 3, pb: 1 }}>
          <Box
            sx={{
              width: 100,
              height: 80,
              overflow: "hidden",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              background: `radial-gradient(circle at center, #fff 20%, rgba(255,255,255,0.7) 50%, transparent 100%)`,
              boxShadow: "0 0 15px rgba(255,255,255,0.2)",
              transition: "transform 0.3s ease-in-out",
              "&:hover": { transform: "scale(1.05)" },
              cursor: "pointer"
            }}
            onClick={handleHome}
          >
            <Box
              component="img"
              src={logo}
              alt="Logo"
              sx={{
                width: "90%",
                borderRadius:1,
                height: "auto",
                objectFit: "contain",
              }}
            />
          </Box>
        </Box>


        {/* Encabezado con título y descripción */}
        <Box sx={{ textAlign: "center", mt: 2, mb: 2 }}>
          <strong style={{ fontSize: "1.3rem", color: "white" }}>Menú principal</strong>
          <Box sx={{ fontSize: "0.8rem", color: "#ddd", mt: 0.5 }}>Accede a todas las secciones del sistema</Box>
        </Box>

        <Divider sx={{ backgroundColor: "white", width: "100%" }} orientation="horizontal" />

        <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto', pr: 0.5 }}>
        <List>
          {/* Página de Inicio (sin expandible) */}
          <ListItem disablePadding>
            <ListItemButton onClick={() => handleHome()}>
              <ListItemIcon sx={{ color: "white" }}><Home /></ListItemIcon>
              <ListItemText primary="Inicio" />
            </ListItemButton>
          </ListItem>

          {/* Otras páginas */}
          {pages.map(({ text, icon, subitems }, index) => (
            <div key={text}>
              <ListItem disablePadding>
                <ListItemButton onClick={() => (subitems ? handleExpand(index) : handleNavigateAndClose(text))}>
                  <ListItemIcon sx={{ color: "white" }}>{icon}</ListItemIcon>
                  <ListItemText primary={text} />
                  {subitems ? (expanded === index ? <ExpandLess /> : <ExpandMore />) : null}
                </ListItemButton>
              </ListItem>
              {subitems && (
                <Collapse in={expanded === index} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {subitems.map((subItem) => (
                      <ListItem key={subItem.text} sx={{ pl: 4 }}>
                        <ListItemButton onClick={() => handleNavigateAndClose(subItem.link)}>
                          <ListItemText primary={subItem.text} />
                        </ListItemButton>
                      </ListItem>
                    ))}
                  </List>
                </Collapse>
              )}
            </div>
          ))}
        </List>
        </Box>

        {/* Footer opcional */}
        <Box sx={{ width: "100%", textAlign: "center", fontSize: "0.75rem", opacity: 0.7, py: 1, borderTop: '1px solid rgba(255,255,255,0.2)' }}>
          © 2025 Super Tienda Xelaju
        </Box>
      </Box>
    </Drawer>
  );
};

export default MobileDrawer;
